import request from '@/util/request';

// export const getList = (params, options) =>
// request.get('/api/device/page', Object.assign({}, options, { params }));

// export const remove = (params, options) =>
// request.post('/api/device/remove', qs.stringify(params),options);

//获取顶级科室部门：（后端设计如此，获取顶级和非顶级用不同的接口）
export const getProjectDeptTopLevel = (params, options) =>
    request.get('/api/device/getProjectDept', Object.assign({}, options, { params }));
//获取非顶级科室(部门)
export const getProjectDept = (params, options) =>
    request.get('/api/v4ward/dept/child-node', Object.assign({}, options, { params }));
//设备数量统计
export const getDeviceNum = (params, options) =>
    request.get('/api/device/statistics/getDeviceNum', Object.assign({}, options, { params }));
//设备巡检正常异常数量统计
export const getInspectNum = (params, options) =>
    request.get('/api/device/statistics/getInspectNum', Object.assign({}, options, { params }));
//设备维修成本统计
export const getRepairCost = (params, options) =>
    request.get('/api/device/statistics/getRepairCost', Object.assign({}, options, { params }));
//维保成本统计
export const getUpkeepCost = (params, options) =>
    request.get('/api/device/statistics/getUpkeepCost', Object.assign({}, options, { params }));